export enum BannerAction {
    ADD, ADD_REMOVE, DELETE
}

export enum BannerType {
    MAP_BANNER = 'map-banner',
    LOWER_BANNER = 'lower-banner',
    SCREENSAVER = 'screensaver',
}
